import { useSEO } from "../hooks/useSEO";

export default function Privacy() {
  useSEO({
    title: "Privacy Policy - Qicino Limited | Your Data Protection",
    description: "Read our comprehensive privacy policy. Learn how Qicino Limited collects, uses, and protects your personal information.",
    keywords: "privacy policy, data protection, privacy, GDPR, personal information",
    url: "https://qicino.com/privacy",
  });

  return (
    <div className="min-h-screen bg-background">
      <div className="container mx-auto px-6 py-16">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-bold text-foreground mb-8">
            Privacy Policy
          </h1>

          <div className="prose prose-invert max-w-none space-y-6 text-muted-foreground">
            <section>
              <h2 className="text-2xl font-bold text-foreground mb-4">
                Introduction
              </h2>
              <p>
                Your privacy is important to us. This Privacy Policy explains how Qicino
                Limited collects, uses, discloses, and otherwise processes your personal
                information in connection with our websites, applications, and services.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-foreground mb-4">
                Information We Collect
              </h2>
              <p>
                We may collect information about you in various ways, including:
              </p>
              <ul className="list-disc list-inside space-y-2">
                <li>
                  Information you provide directly (name, email, phone number, company details)
                </li>
                <li>Automatically collected information (IP address, browser type, pages visited)</li>
                <li>Cookies and similar tracking technologies</li>
                <li>Information from third-party sources</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-foreground mb-4">
                How We Use Your Information
              </h2>
              <p>We use collected information to:</p>
              <ul className="list-disc list-inside space-y-2">
                <li>Provide and improve our services</li>
                <li>Respond to your inquiries and requests</li>
                <li>Send marketing communications (with your consent)</li>
                <li>Analyze usage patterns and improve our website</li>
                <li>Comply with legal obligations</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-foreground mb-4">
                Data Security
              </h2>
              <p>
                We implement appropriate technical and organizational measures to protect
                your personal information against unauthorized access, alteration, disclosure,
                or destruction.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-foreground mb-4">
                Your Rights
              </h2>
              <p>
                You have the right to access, correct, or delete your personal information.
                To exercise these rights, please contact us at{" "}
                <a href="mailto:info@qicino.com" className="text-primary hover:underline">
                  info@qicino.com
                </a>
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-foreground mb-4">
                Contact Us
              </h2>
              <p>
                If you have questions about this Privacy Policy, please contact us at:
              </p>
              <p>
                <strong>Email:</strong>{" "}
                <a href="mailto:info@qicino.com" className="text-primary hover:underline">
                  info@qicino.com
                </a>
                <br />
                <strong>Address:</strong> Lagos, Nigeria
              </p>
            </section>

            <div className="border-t border-border pt-6 mt-8">
              <p className="text-sm text-muted-foreground">
                Last updated: March 2026. Qicino Limited reserves the right to update this
                Privacy Policy at any time. Changes will be effective immediately upon posting.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
